import {
  type GcfCommonComponentConfigInterface,
  type GcfShelfStyleInterface,
  IFlexDyHeader,
} from 'src/features/components/editComponentPage/forms/FormSelector.interface';

import type { ICCAsset } from './Assets';
import { IStatus } from './Common';
import { IComponentType } from './ComponentType';
import type { IThemeRes } from './GCFThemes';
import { ILayoutType } from './LayoutType';
import type { IPhase } from './Phase';
import {
  type IGcfProductList,
  type IProductCategory,
  type IProductVariation,
  IGcfProductListProductImage,
} from './Product';

/* GCF interfaces */
export interface IGcfComponentConfig extends GcfCommonComponentConfigInterface {
  /**
   * @deprecated since R21
   */
  flavor: {
    visible: boolean;
  };
  isFlavourCycling: boolean;
  showComponentProductDisclaimer: boolean;
  ads?: {
    showPlaceholder?: boolean;
    isAdsEnabled?: boolean;
  };

  /**
   * @deprecated since R13
   */
  scaleTypes?: string;
  /**
   * @deprecated since R13
   */
  scaleTypeKey: string;

  productStyle: {
    color: string;
  };
  productList: IGcfProductList;

  //LVG & LOV
  lineupColumns?: number;
  marginBottom?: number;
  columnStyle?: ColumnStyle;
  listingHeight?: number;
  showAllVisuals?: boolean;

  //Single Shelf
  lineupStyle?: GcfShelfStyleInterface;
  productsSource?: DyProductSource | 'Products';

  //DY
  knownCustomer?: IFlexDyHeader;
  unknownCustomer?: IFlexDyHeader;

  dyHeaders?: {
    [key in DyProductSource]?: {
      known?: string;
      unknown?: string;
    };
  };

  //Disclaimer
  text?: string;
  images?: IGcfProductListProductImage[];
}

export enum DyProductSource {
  DYS = 'DYS',
  DYR = 'DYR',
}

export enum ColumnStyle {
  CONTINUOUS = 'continuous',
  CATEGORY = 'category',
}

export enum ShelfStyleEnum {
  STAGGERED = 'STAGGERED',
  STRAIGHT = 'STRAIGHT',
}

export enum ShelfProductPatternEnum {
  DEFAULT = 'DEFAULT',
  IMAGE_BELOW_TEXT = 'IMAGE_BELOW_TEXT',
}

export enum ShelfPatternEnum {
  FROM_TOP = 'FROM_TOP',
  FROM_BOTTOM = 'FROM_BOTTOM',
  NORMAL = 'NORMAL',
}

export enum ShelfPositionEnum {
  CENTER = 'CENTER',
  BOTTOM = 'BOTTOM',
}

export enum OrderLabelEnum {
  number = 'number',
  alphabet = 'alphabet',
}

/* CC-BE interfaces */
export interface IComponent<T = any> {
  id: number;
  name: string;
  thumbnail_url?: string;
  layout_type_id: number;
  layoutType?: ILayoutType;
  component_type_id: number;
  width: number;
  height: number;
  usable_as_override: boolean;
  /* 
    Change the property "config" to type "any" to fix a TypeScript error: "Type instantiation is excessively deep and possibly infinite."
  */
  config: T;
  status: IStatus;
  start_date: string | null;
  end_date: string | null;
  product_category_id: number[];
  productCategories?: IProductCategory[];
  created_at: string;
  modified_at: string;
  component_type?: IComponentType;
  product_variation_product_code: string[];
  productVariations?: IProductVariation[];
  component_tag_id: number[];
  componentTags?: IComponentTag[];
  theme_id?: number;
  theme?: IThemeRes;
  asset_id: number[];
  assets?: ICCAsset[];
  phase?: IPhase | undefined;
}

export interface IComponentTag {
  id: number;
  name: string;
  created_at: string;
  modified_at: string;
}

export interface IComponentTagWithComponentCount {
  id: number;
  name: string;
  components_count: number;
  created_at: string;
  modified_at: string;
}
